import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { loadLocales, loadRegistrationLocales } from 'redux/modules/api/locales'
import { changeLocale } from 'redux/modules/app'

function decorator(config = {}) {
  return ComposedComponent => {
    @connect(
      ({ api, app }) => ({
        locales: api.locales,
        locale: app.locale
      }),
      { loadLocales, loadRegistrationLocales, changeLocale }
    )
    class apiLocales extends Component {
      static propTypes = {
        loadLocales: PropTypes.func.isRequired,
        locales: PropTypes.object,
        loadRegistrationLocales: PropTypes.func.isRequired
      }

      handleLoadRegistrationLocales = orgId => {
        return orgId && this.props.loadRegistrationLocales(orgId)
          .then(({ body }) => {
            return body
          })
          .catch(this.handleError)
      }

      componentDidMount() {
        if (config.loadIfEmpty) {
          const { locales } = this.props

          !locales.data.length &&
            !locales.loading &&
            config.loadLocales &&
            this.props.loadLocales()
          return
        }

        config.loadLocales && this.props.loadLocales()
      }

      render() {
        return <ComposedComponent
          {...this.props}
          loadRegistrationLocales={this.handleLoadRegistrationLocales}
        />
      }
    }
    return apiLocales
  }
}

export default decorator
